export default "__VITE_ASSET__DFH0uNRB__"